import { getBillingPlansApi } from '@/api/v1/billing/getBillingPlansApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';

export const getBillingPlans = async () => {
  try {
    const response = await getBillingPlansApi();

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
